import React from 'react';
import './Qsite.css';

export default function Header({ url, name }) {
	return <img className='hdrImg mb-2' src={url} alt={name} />;
}
